// libs
import React from 'react';
import PropTypes from 'prop-types';
// shared components
import { LocaleString } from '@biw/intl';
import CatalogButton from '../shop/catalog-button';
//scss
import './final-results.scss';

export default class FinalResults extends React.Component {

    static defaultProps = {
        hasResults: false,
        totalPoints: 0,
        contentRole: '',
        headlineCode: '',
        subheadlineCode: '',
        messageCode: '',
        additionalMessageCode: '',
        replaceOptions: {}
    };

    static propTypes = {
        hasResults: PropTypes.bool,
        contentRole: PropTypes.string,
        totalPoints: PropTypes.number,

        headlineCode: PropTypes.string,
        subheadlineCode: PropTypes.string,
        messageCode: PropTypes.string,
        additionalMessageCode: PropTypes.string,
        replaceOptions: PropTypes.shape( {
            totalBonusPoints: PropTypes.string,
            totalBaseEarnings: PropTypes.string,
            totalPoints: PropTypes.string,
            potentialAward: PropTypes.string,
            goalPoints: PropTypes.string,
            bonusPoints: PropTypes.string,
            levelName: PropTypes.string,
            paxAchievedCount: PropTypes.number,
            managerRange: PropTypes.bool,
            mediaLabel: PropTypes.string
        } )
    };

    render() {
        const {
            hasResults,
            totalPoints,
            contentRole,
            headlineCode,
            subheadlineCode,
            messageCode,
            additionalMessageCode,
            replaceOptions
         } = this.props;

        if ( !hasResults ) {
            return <div />;
        }

        return (
            <div className="final-results-banner branding-primary-bg-color">
                <h2><LocaleString code={ `finalResults.${contentRole}.${headlineCode}` } replaceOptions={ replaceOptions } /></h2>
                <h3><LocaleString code={ `finalResults.${contentRole}.${subheadlineCode}` } replaceOptions={ replaceOptions } /></h3>
                <p>
                    { messageCode &&
                        <LocaleString code={ `finalResults.${contentRole}.${messageCode}` } replaceOptions={ replaceOptions } />
                    }
                    <br/>
                    { additionalMessageCode &&
                        <LocaleString code={ `finalResults.${contentRole}.${additionalMessageCode}` } replaceOptions={ replaceOptions }/>
                    }
                </p>

                { totalPoints > 0 &&
                    <div>
                        <CatalogButton brandingInverted buttonLocaleCode="goalSelection.catalogLink" />
                    </div>
                }
            </div>
        );
    }

}
